module.exports = __webpack_public_path__ + "static/media/user-notif.7880426c.svg";